// BookingWorkflowModal.jsx
import React from "react";
import classes from "./howBookingsWorkModal.module.css";

const HowBookingsWorkModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <button className={classes.closeButton} onClick={onClose}>
          &times;
        </button>

        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>
            Understanding the Booking Process
          </h2>
          <p className={classes.modalSubtitle}>
            From inquiry to payment - here's how bookings work on ArtistNextDoor
          </p>
        </div>

        <div className={classes.workflowContainer}>
          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>🆕</span>
              </div>
              <h3 className={classes.stageName}>Pending Approval</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                When a client books you, they pay a token amount as a booking
                deposit.
              </p>
              <p>
                The booking appears in your{" "}
                <span className={classes.highlight}>Pending Approval</span>{" "}
                section.
              </p>
              <p className={classes.note}>
                ⏱️ You have <span className={classes.alert}>24 hours</span> to
                accept or reject the booking.
              </p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>💰</span>
              </div>
              <h3 className={classes.stageName}>Awaiting Payment</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                Once you <span className={classes.highlight}>accept</span> the
                booking, the client is notified to complete the full payment.
              </p>
              <p>
                The booking moves to{" "}
                <span className={classes.highlight}>Awaiting Payment</span>{" "}
                section.
              </p>
              <p className={classes.note}>
                Note: Client details are only revealed after full payment is
                made.
              </p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>📅</span>
              </div>
              <h3 className={classes.stageName}>Upcoming</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                After the client completes the full payment, the booking is
                confirmed.
              </p>
              <p>
                The booking moves to the{" "}
                <span className={classes.highlight}>Upcoming</span> section.
              </p>
              <p>
                You can now see the client's complete contact details and event
                information.
              </p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>✅</span>
              </div>
              <h3 className={classes.stageName}>Completed</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                After you've performed at the event, the booking is marked as
                completed.
              </p>
              <p>
                The payment is held for 3 days to allow for any client
                complaints.
              </p>
              <p>
                If no issues arise, the payment is automatically released to
                your account.
              </p>
              <p className={classes.note}>
                The booking moves to the{" "}
                <span className={classes.highlight}>Completed</span> section
                once everything is finalized.
              </p>
            </div>
          </div>
        </div>

        <div className={classes.securityNote}>
          <h4 className={classes.securityTitle}>💡 Important Notes</h4>
          <ul className={classes.securityList}>
            <li>We handle all payments to ensure security for both parties</li>
            <li>Client details are only revealed after full payment is made</li>
            <li>You must respond to booking requests within 24 hours</li>
            <li>
              Payments are released 3 days after completion (if no disputes)
            </li>
          </ul>
        </div>

        <div className={classes.modalFooter}>
          <button className={classes.actionButton} onClick={onClose}>
            Got It
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowBookingsWorkModal;
